import { Injectable, signal } from '@angular/core';
import { getAuthRedirectError } from './ensure-signed-in';

@Injectable({
  providedIn: 'root'
})
export class AuthSession {
  readonly authenticated = signal(false);
  readonly error = signal<string | null>(getAuthRedirectError());

  markSignedIn(): void {
    this.authenticated.set(true);
    this.error.set(null);
  }

  markSignedOut(message: string | null): void {
    this.authenticated.set(false);
    this.error.set(message);
  }
}
